import { useAppointmentStore } from 'src/stores/appointment';
import { RuntimeStoreContext } from 'src/types/runtime/piniaRuntimeContext';

import { QueryStore } from 'src/util/query/QueryStore';

const warmupTimerList = (_store: RuntimeStoreContext, queryStore: QueryStore) => {
	const appointmentStore = useAppointmentStore();

	void appointmentStore.fetchRunningAppointmentTimer({
		queryStore: queryStore,
	});
};

export { warmupTimerList };
